import { Dispatch, Fragment, SetStateAction } from "react"
import { TestResultForm } from "../../types"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs, { Dayjs } from "dayjs"

type ResultDateField = {
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
}

const ResultDateField = (props: ResultDateField) => {
  const { formData, setFormData } = props

  const handleChange = (value: Dayjs | null) => {
    const nextForm = structuredClone(formData)

    const resultDate = value?.isValid()
      ? value.toISOString() 
      : null

    nextForm.report_date = resultDate

    setFormData(nextForm)
  }

  const label =  'Result Date *'
  const value = formData.report_date ? dayjs(formData.report_date) : null

  return (
    <Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
        <DatePicker
          label={label}
          defaultValue={dayjs(new Date())}
          slotProps={{ textField: { size: 'small' } }}
          value={value}
          onChange={selectedDate => handleChange(selectedDate)}
          format="MM-DD-YYYY"
        />
      </LocalizationProvider>
    </Fragment>
  )
}

export default ResultDateField
